import type { NetRevenueReference } from 'lumen/utils/net-revenue/types';

export interface Money {
  currency: string;
  value: number;
}

export interface RawReference {
  capacity?: number;
  cost?: Money | number | null;
  net_revenue?: Money | number | null;
  room_nights: number;
  room_revenue?: Money | number | null;
  type: string;
}

export function flattenMoney(
  money: Money | number | null | undefined,
): number | null {
  if (money === null || money === undefined) {
    return null;
  }
  if (typeof money === 'number') {
    return money;
  }
  return money.value;
}

export function normalizeReferences(
  raw: RawReference[] | null | undefined,
): NetRevenueReference[] {
  return (raw ?? []).map((reference) => ({
    capacity: reference.capacity,
    cost: flattenMoney(reference.cost),
    netRevenue: flattenMoney(reference.net_revenue) ?? 0,
    roomNights: reference.room_nights,
    roomRevenue: flattenMoney(reference.room_revenue) ?? 0,
    type: reference.type,
  }));
}
